<template>
  <div>
    <b-card v-bind="{ ...$attrs, ...commonAttrs }" v-on="$listeners">
      <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName" />
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  computed: {
    commonAttrs() {
      return {
        class: 'list-card',
        headerBgVariant: 'transparent',
        headerClass: 'd-flex align-items-center pt-0 border-0 ',
        bodyClass: 'pt-0',
        footerBorderVariant: 'transparent',
        footerBgVariant: 'transparent',
        footerClass: 'd-flex align-items-center justify-content-end border-0',
        titleTag: 'h6',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.list-card {
  flex-basis: 425px;
  font-size: 12px;
  border-radius: 34px;
  padding: 27px;
  height: 300px;
}
</style>
wrap
